var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-sections-inner-grid"},[_c(_setup.PasswordSetting),(!_setup.isGuest)?_c('div',[_c('h4',[_vm._v(_vm._s(_vm.$t('settings.security.2fa')))]),_c('div',{staticClass:"bc-form-grid"},[_c(_setup.TwoFactorMethodSetting),_c(_setup.MobileNumberSetting),_c(_setup.TwoFactorAuthSettings)],1)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }